import axios from "../_snowpack/pkg/axios.js";
import {API_URL} from "../consts/common.const.js";
export const getBotSettings = (requestBody) => {
  return axios.post(`${API_URL}botsetting/botConfig/${window.customToken}`, requestBody);
};
